<template>
    <div
        class="spinner"
        :style="{
            'font-size': `${size}px`
        }">
            <sw-icon class="spinner_icon"  name="spinner9" />
            <span v-if="text && text.trim()" class="spinner_text">{{ text }}</span>
    </div>
</template>

<script setup>
defineProps({
    size: {
        type: String,
        default: '20'
    },
    text: {
        type: String,
        default: ''
    }
});
</script>

<style lang="scss" scoped>
    .spinner{
        margin: auto;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.25em;
    }

    .spinner_icon{
        transform-origin: center;
        animation: rotateSppiner var(--durationSlow, 2s) linear infinite;
    }

    .spinner_text{
        font-size: 0.75em;
        color: var(--textSecondary, #64748b);
        font-weight: 500;
        margin-top: 0.25em;
        white-space: nowrap;
    }

    @keyframes rotateSppiner {
        to{
            transform: rotate(0deg);
        }

        from{
            transform: rotate(-360deg);
        }
    }
</style>